<template>
  <!-- 存放搜索页所有类型列表组件 -->
  <div class="allDetails">
    <Zh v-if="active === 1" />
    <Lw v-if="active === 2" />
    <Zx v-if="active === 3" />
    <Zz v-if="active === 4" />
    <Hy v-if="active === 5" />
    <Xz v-if="active === 6" />
    <Qk v-if="active === 7" />
    <Jg v-if="active === 8" />
    <Ml v-if="active === 9" />
    <KC v-if="active === 10" />
    <BG v-if="active === 11" />
  </div>
</template>

<script>
import Zh from "@/views/mobileView/search/searchList/Zhlist.vue";
import Lw from "@/views/mobileView/search/searchList/Lwlist.vue";
import Zx from "@/views/mobileView/search/searchList/Zxlist.vue";
import Zz from "@/views/mobileView/search/searchList/Zzlist.vue";
import Hy from "@/views/mobileView/search/searchList/Hylist.vue";
import Xz from "@/views/mobileView/search/searchList/Xzlist.vue";
import Qk from "@/views/mobileView/search/searchList/Qklist.vue";
import Jg from "@/views/mobileView/search/searchList/Jglist.vue";
import Ml from "@/views/mobileView/search/searchList/Mllist.vue";
import KC from "@/views/mobileView/search/searchList/Kclist.vue";
import BG from "@/views/mobileView/search/searchList/Bglist.vue";
export default {
  name: "Details",
  components: {
    Zh,
    Lw,
    Zx,
    Zz,
    Hy,
    Xz,
    Qk,
    Jg,
    Ml,
    KC,
    BG
  },
  props: {
    active: {
      type: Number,
    },
  },
};
</script>

<style scoped lang="scss">
.allDetails {
  padding: 12px;
  width: 100%;
}
</style>
